module.exports = __webpack_public_path__ + "img/d18.ccba1538.png";